<template>
    
    <v-card outlined shaped>
        <v-card-title >
            Radiation Source Report
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="10">
                    <v-text-field 
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details="">
                        </v-text-field>
                </v-col>
                <v-col cols="2">
                    <vue-excel-xlsx
                        :data="radiationList"
                        :columns="headersExport"
                        :file-name="fileName"
                        :file-type="'xlsx'"
                        :sheet-name="'sheetname'">

                            <v-btn color="blue-grey" class="ma-2 white--text">
                                Export<v-icon right >mdi-cloud-download</v-icon>
                            </v-btn>
                            
                    </vue-excel-xlsx>
                </v-col>
            </v-row>
        </v-card-text>
            
        
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="radiationList"
                    :search="search"
                    :items-per-page="10"
                    class="elevation-1"
                    @current-items="getFiltered"
                    >

                </v-data-table>

                
            </v-card-text>

        </v-card>
    
</template>

<script>

import reportsAPI from '@/services/reportsservice';
import moment from 'moment';

export default {
    name:'RadiationReport',
    data:function(){
        return{
            fileName:'FullReport'+moment(Date.now()).format('YYYY-MM-DD'),
            search:'',
            radiationList:[],
            filteredItems:[]
        }
    },
    computed:{
        headers(){
            return [
                { text:'Serial Number', align:'start', sortable:true, value:'serialNumber'},
                { text:'Building', align:'start', sortable:true, value:'building'},
                { text:'Floor', align:'start', sortable:true, value:'floor'},
                { text:'Location', align:'start', sortable:true, value:'location'},
                { text: 'Has a Shutter', align:'start' , sortable: true, value:'shutt'},
                { text:'Isotope', value:'isotope'},
                { text:'MCI', align:'start', sortable:true, value:'mci'},
                { text:'Leak Test Interval', value:'leak'},
                { text:'Leak Test Group', align:'start', sortable:true, value:'leakTestGroupCode'},
                { text:'Holder', align:'start', sortable:true, value:'holderCode'},
                { text: 'Holder Serial Number', align:'start' ,sortable:true, value:'holderSerialNumber'},
                { text:'P&ID Tag', align:'start', sortable:true, value:'tag'},
                { text:'PO', align:'start', sortable:true, value:'po'},
                { text:'MFG', align:'start', sortable:true, value:'mfg'},
                { text:'Use Bulding', align:'start', sortable:true, value:'useBuilding'},
                { text:'Install Status', align:'start', sortable:true, value:'installed'},
                { text:'Secure By Lock and Cable', align:'start', sortable:true, value:'secureByLock'},
                { text:'Reason Not Secure', align:'start', sortable:true, value:'reasonNotSecure'},
                { text:'Received Date', align:'start', sortable:true, value:'receiveDate'},
                { text:'Update', align:'start', sortable: true, value:'update'},
                { text:'Transfer Letter Filed', align:'start', sortable:true, value:'verified'},
                { text:'Management Contact', align: 'start', value:'users'},
                { text:'Primary Contact', align:'start', value:'primaryContact'}
            ]
        },
        headersExport(){
            return [
                { label: 'Serial Number',  field:'serialNumber'},
                { label:'Building',  field:'building'},
                { label:'Floor',  field:'floor'},
                { label:'Location',  field:'location'},
                { label: 'Has a Shutter', align:'start' , sortable: true, field:'shutt'},
                { label:'Isotope', field:'isotope'},
                { label:'MCI',  field:'mci'},
                { label:'Leak Test Interval', field:'leak'},
                { label:'Leak Test Group',  field:'leakTestGroupCode'},
                { label:'Holder',  field:'holderCode'},
                { label:'Holder serial Number',  field:'Holder Serial Number'},
                { label:'P&ID Tag',  field:'tag'},
                { label:'PO',  field:'po'},
                { label:'MFG',  field:'mfg'},
                { label:'Use Bulding',  field:'useBuilding'},
                { label:'Install Status',  field:'installed'},
                { label:'Secure By Lock and Cable',  field:'secureByLock'},
                { label:'Reason Not Secure',  field:'reasonNotSecure'},
                { label:'Received Date',  field:'receiveDate'},
                { label:'Update',  field:'update'},
                { label:'Transfer Letter Filed',  field:'verified'},
                { label:'Contact Person', field:'users'},
                { label:'Primary Contact', field:'primaryContact'}
            ]
        }
    },
    methods:{
        loadReport: async function(){
            reportsAPI.getFullReportList()
            .then(response=>{
                this.radiationList=response.data;
            })
            .catch(error=>{console.log(error)});
        },
        async getFiltered(e){
             this.filteredItems=e;
        }
    },
    mounted:function(){
        this.loadReport();
    }
}
</script>
